import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/motion";
import { api } from "../lib/api";
import { IMAGES } from "../data/site";
import { ArrowUpRight, Loader2 } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState(null);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => setPosts([])); }, []);

  return (
    <div data-testid="blog-page">
      <PageHero eyebrow="Blog · Kerala Travel Guides" title={["Stories from", "God's Own Country."]}
        subtitle="Tips, guides and inspiration to help you plan the perfect Kerala escape from Mumbai." image={IMAGES.munnarHero} />
      <section className="max-w-[1400px] mx-auto px-5 lg:px-10 py-24">
        {posts === null ? (
          <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-emerald" /></div>
        ) : posts.length === 0 ? (
          <p className="text-center text-ink/50 py-20">No articles yet. Check back soon.</p>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((p, i) => (
              <Reveal key={p.id} delay={(i % 3) * 0.08}>
                <Link to={`/blog/${p.slug}`} className="group flex flex-col bg-white border border-emerald/10 hover:-translate-y-1 hover:shadow-xl hover:shadow-black/5 transition-all duration-300 h-full" data-testid={`blog-card-${p.slug}`}>
                  <div className="overflow-hidden h-56">
                    <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <div className="p-7 flex flex-col flex-1">
                    <span className="eyebrow text-gold mb-3">{p.category}</span>
                    <h3 className="font-serif text-2xl text-emerald leading-tight">{p.title}</h3>
                    <p className="text-ink/60 text-sm mt-3 leading-relaxed line-clamp-3">{p.excerpt}</p>
                    <span className="mt-auto pt-5 flex items-center gap-1 text-emerald text-sm font-medium">Read more <ArrowUpRight className="w-4 h-4" /></span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
